module.exports = {
  Rating: {
    PluginName: "Sıralama",
    content_box_name: "İçerik ",
    Statement: "Etkileşim",
    Question: "Soru",
    Answer: "Cevap",
    Feedback: "Geri Bildirim",
    FeedbackMsg:
      "Cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    TrueFeedbackMsg:
      "Doğru cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    FalseFeedbackMsg:
      "Yanlış cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    ShowFeedback: "Geri bildirim mesajı göster",
    ShowStars: "Sayılar yerine yıldızları göster",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    pos: "Konum",
    radius: "Radius",
    source: "Kaynak",
    Answer: "Cevap",
    Number: "Seviye Sayısı",
    CheckAnswer: "Kontrol Et ",
    tryAgain: "Tekrar Dene",
    checkAnswer: "Kontrol Et",
  },
};
